<div id="favoriteLocationListItem-text-label-{{ favoriteLocation.label | camelCase }}" data-private>
  {{ favoriteLocation.label }}<br />
  {{ favoriteLocation.location.display }}
</div>
<div class="buttons">
  <button
    id="favoriteLocationListItem-button-select-{{ favoriteLocation.label | camelCase }}"
    mat-stroked-button
    color="primary"
    (click)="selectFavoriteLocation()"
  >
    Select
  </button>
  <button
    id="favoriteLocationListItem-button-delete-{{ favoriteLocation.label | camelCase }}"
    (click)="deleteFavoriteLocation()"
    mat-icon-button
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
